import {
  CommonComputedWidgetConfigComponent,
  IWidgetComponentProps,
} from '@framework/engine';
import { FormItem } from '@framework/form';
import * as React from 'react';
import { MacroBurdenTypeSelectInput } from '../../../schema/macro-burden-types/BurdenTypeSelectInput';
import { IBurdenWidget } from './IBurdenWidget';

export interface IBurdenWidgetConfigComponentProps
  extends IWidgetComponentProps<IBurdenWidget> {}

export function BurdenWidgetConfigComponent(
  props: IBurdenWidgetConfigComponentProps,
) {
  return (
    <div>
      <FormItem
        name={'macroBurdenTypeId'}
        label={'Macro tipo di onere'}
        help={
          'Indica il macro tipo di onere da utilizzare. Il tipo onere deve essere configurato a livello di singolo ufficio e verrà selezionato automaticamente dal sistema in base alla Competenza selezionata dal richiedente.'
        }
      >
        <MacroBurdenTypeSelectInput
          name="macroBurdenTypeId"
          objectName="macroBurdenType"
        />
      </FormItem>
      <CommonComputedWidgetConfigComponent
        {...props}
        expressionLabel="Importo"
      />
    </div>
  );
}
